import { useMutation } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import { userService } from 'src/services/user.service'

const useGetUsers = () => {
  return useMutation([QUERY_KEYS.USERS], (params: any) => userService.getUsers(params))
}

export { useGetUsers }
